module.exports = __webpack_public_path__ + "img/following-step02.dc21f367.svg";